/**
 * «Що робитиме установка» (owner, 23.10.2026, after YASNO's autopilot screen):
 * today's 6 windows as the hours the battery charges from the grid and the
 * hours it covers the consumption, each up to / down to its SOC. Adjacent
 * windows of one kind with one SOC make one span. Pure.
 */
import type { DeyeWindow } from 'shared';

export interface ProgramSpan {
  /** Hour labels of the day axis, «00:00»–«06:00». */
  from: string;
  to: string;
  socPct: number | null;
}

export interface ProgramSummary {
  /** Grid charge, up to the SOC. */
  charge: ProgramSpan[];
  /** The battery covers the consumption, down to the SOC. */
  discharge: ProgramSpan[];
}

/** `labels` — the day's hour labels with the day's end (`n + 1` of them). */
export function programSummary(
  windows: readonly DeyeWindow[],
  labels: readonly string[],
  n: number,
): ProgramSummary {
  const spans = (pick: (w: DeyeWindow) => boolean): ProgramSpan[] => {
    const out: ProgramSpan[] = [];
    let last: { end: number; soc: number | null } | null = null;
    windows.forEach((w, i) => {
      const end = windows[i + 1]?.start_hour ?? n;
      if (!pick(w) || end <= w.start_hour) return;
      const prev = out.at(-1);
      if (prev && last && last.end === w.start_hour && last.soc === w.soc_pct) {
        prev.to = labels[end] ?? prev.to;
      } else {
        out.push({ from: labels[w.start_hour] ?? '', to: labels[end] ?? '', socPct: w.soc_pct });
      }
      last = { end, soc: w.soc_pct };
    });
    return out;
  };
  return {
    charge: spans((w) => w.mode === 'grid_charge' && w.power_kw > 0),
    discharge: spans((w) => w.mode === 'self_consumption' && w.power_kw > 0),
  };
}
